import { render, staticRenderFns } from "./UserViewer.vue?vue&type=template&id=4a4a2b41&"
import script from "./UserViewer.vue?vue&type=script&lang=js&"
export * from "./UserViewer.vue?vue&type=script&lang=js&"
import style0 from "./UserViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports